<template>
  <div>
    <el-dialog :visible.sync="dialogOpen" :title="$t('taskStatus.completedTaskResult')" center>
      <div class="dialog-buttons">
        <result-log-button :queueId="queueId"></result-log-button>
        <files-select :queueId="queueId"></files-select>
      </div>
    </el-dialog>

    <div class="task-status-line">
      <el-tag
        class="task-status-element"
        v-for="task in getMyTasksForTabs"
        :key="task.pid"
        closable
        :type="task.icon"
        @click="taskClicked(task)"
        @close="taskClosed(task)"
      >
        <i :class="task.class" style="margin-right: 2px"></i>
        {{task.caption}}
        <span v-if="task.icon==='info'">&nbsp; &mdash; {{ $t('taskStatus.taskStarted') }}</span>
        <span v-else-if="task.icon==='success'">&nbsp; &mdash; {{ $t('taskStatus.taskCompleted') }}</span>
        <span v-else-if="task.icon==='warning'">&nbsp; &mdash; {{ $t('taskStatus.timeoutExceeded') }}</span>
        <span v-else-if="task.icon==='danger'">&nbsp; &mdash; {{ $t('taskStatus.taskTerminatedAbnormally') }}</span>
      </el-tag>
    </div>
  </div>
</template>


<script>
import { mapGetters } from "vuex";
import ResultLogButton from "./ResultLogButton";
import FilesSelect from "./FilesSelect";
export default {
  data() {
    return {
      dialogOpen: false,
      queueId: null
    };
  },
  methods: {
    taskClicked(value) {
      //console.log(value);
      if (value.icon === "info") {
        this.$message(this.$t('taskStatus.taskInProcess'));
        //TODO: возможность останавливать запущенные задачи
      } 
      else if(value.icon === 'warning'){
        this.$message(this.$t('taskStatus.thisTaskTimedOut'));
        return;
      }
      else {
        this.queueId = value.queueId;
        this.$store.dispatch("getQueueTaskById", value.queueId).then(() => {
          this.dialogOpen = true;
        }).catch(()=>{})
      }
    },
    taskClosed(value) {
      //console.log(value);
      this.$store.commit("removeTaskInMyTasks", value.pid);
    }
  },
  computed: {
    ...mapGetters(["getMyTasksForTabs"])
  },
  components: {
    ResultLogButton,
    FilesSelect
  }
};
</script>


<style scoped>
.dialog-buttons {
  display: flex;
  justify-content: space-between;
}
.task-status-line {
  background: var(--main-background);
  margin-left: 5px;
  min-height: 32px;
}
.task-status-element {
  cursor: pointer;
  margin: 0 10px;
}
</style>
